<template>
  <div class="flex xl3 lg3 md3 pl-4 py-5 mt-2">
    <!-- <div v-if="hotspot_id && hotspot" class="layout content-bg--3 pl-4 mb-3">
      <div class="flex md6 font-weight-medium py-4 pl-2">
        {{ hotspot.sms.cntMonth }} СМС
        <label class="subtitle-2 font-weight-regular text--secondary">
          отправлено в рамках тарифа
        </label>
      </div>
      <div class="flex md6 font-weight-medium py-4 pl-3">
        {{ hotspot.sms.sumOverLimit }} СМС
        <label class="subtitle-2 font-weight-regular text--secondary">
          отправлено сверх тарифа
        </label>
      </div>
    </div> -->
    <div v-if="hotspot_id && hotspot" class="content-bg--3 py-4 pl-4">
      <div class="py-2 pl-2">
        <h5>{{ hotspot.title }}</h5>
        <h3>
          <span v-if="hotspot.ssid_hotspot">{{ hotspot.ssid_hotspot }}</span>
          <span v-else>нет</span>
          <v-tooltip v-if="timer && timer.isActive" left>
            <template slot="activator">
              <icon-clock></icon-clock>
            </template>
            <span>
              Название сети можно поменять через:
              <span>{{ formatted }}</span>
            </span>
          </v-tooltip>
          <span v-else class="text-no-wrap">
            <v-btn
              @click="
                $emit('openDialog', {
                  component: 'hotspotEditWifi',
                  param: 'ssid_hotspot',
                  id: hotspot.id
                })
              "
              icon
              class="ma-0 pb-1"
            >
              <icon-pencil></icon-pencil>
            </v-btn>
          </span>
        </h3>
        <label
          class="subtitle-1 font-weight-regular text--secondary text-capitalize"
        >
          {{ hotspot.address }}
        </label>
      </div>
      <div v-if="hotspot" class="py-2 pl-2">
        <h5>Баланс СМС:</h5>
        <h3
          v-if="hotspot.sms"
          class="font-weight-bold pt-1"
          :class="{
            'error--text': hotspot.sms.balance < 0
          }"
        >
          {{ hotspot.sms.balance }}
          <div class="subtitle-1 font-weight-regular text--secondary py-2">
            до {{ end }}
          </div>
          <div class="subtitle-1 text--secondary font-weight-regular">
            {{ hotspot.sms.cntMonth }} СМС потрачено с {{ start }}
          </div>
        </h3>
      </div>
      <div class="pt-2">
        <router-link
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
          :to="{
            name: 'statisticsGeneral',
            params: { hotspotName: hotspotName }
          }"
          class="subtitle-2 font-weight-medium link layout align-center mb-3 text--primary"
        >
          <icon-arrow-right class="mr-2"></icon-arrow-right>
          <span class="subtitle-2 font-weight-medium">К статистике</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrowRight from "../icon/IconArrowRight.vue";
import IconPencil from "../icon/IconPencil.vue";
import IconClock from "../icon/IconClock.vue";
import moment from "moment";

export default {
  name: "HotspotWidget",

  components: {
    IconArrowRight,
    IconPencil,
    IconClock
  },

  props: {
    //id хотспота
    hotspot_id: {
      type: Number,
      required: true
    },
    // hotspotName хотспота
    hotspotName: {
      type: String
    }
  },
  data: () => ({}),

  computed: {
    // объект с данными хотспота
    hotspot() {
      return this.$store.getters.getHotspot(this.hotspot_id);
    },
    // старт отсчета периода
    start() {
      return moment()
        .date(1)
        .format("D MMMM");
    },
    // конец отсчета периода
    end() {
      return moment()
        .add(1, "months")
        .date(0)
        .format("D MMMM");
    },
    // значения таймера из store
    timer() {
      return this.$store.getters.timerHotspot[this.hotspot_id];
    },
    // отформатированный вывод значения таймера
    formatted() {
      let minutes = null,
        seconds = null;
      if (this.timer) {
        minutes = Math.floor(this.timer.timerMikrotik / 60);
        seconds = this.timer.timerMikrotik % 60;

        if (minutes < 10) {
          minutes = `0${String(minutes)}`;
        }
        if (seconds < 10) {
          seconds = `0${String(seconds)}`;
        }
      }
      return minutes + ":" + seconds;
    }
  },

  mounted() {
    // если timer в стор не пустой, то отсчет начинается с этого значения
    if (this.timer)
      this.$store.dispatch("runTimer", {
        id: this.hotspot_id,
        timerMikrotik: this.timer.timerMikrotik
      });
  },

  methods: {}
};
</script>
